import { StateCreator } from 'zustand';
import { ErrorSlice } from './error.types';

export const createErrorSlice: StateCreator<
  ErrorSlice,
  [],
  [],
  ErrorSlice
> = () => ({
  etapa: null,
  error: null,
});
